import { n as e } from "../../chunks/index.es.CfT5btWg.js";
import { Transforms as t } from "slate";
//#region lib/Factbox/lib/actionHandler.ts
var n = ({ editor: n, options: r }) => {
	let i = e.getSelectedText(n), a = `${r?.factboxNewTitle ?? "Facts"}:`, o = crypto.randomUUID(), s = [{
		id: o,
		class: "block",
		type: "core/factbox",
		properties: {
			original_id: o,
			original_updated: (/* @__PURE__ */ new Date()).toISOString(),
			created: (/* @__PURE__ */ new Date()).toISOString()
		},
		children: [{
			id: crypto.randomUUID(),
			class: "text",
			type: "core/factbox/title",
			children: [{ text: a }]
		}, {
			id: crypto.randomUUID(),
			class: "block",
			type: "core/factbox/body",
			children: [{
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			}]
		}]
	}], c = e.position(n) + +!i;
	e.insertAt(n, c, s), t.select(n, {
		anchor: {
			offset: a.length,
			path: [
				c,
				0,
				0
			]
		},
		focus: {
			offset: a.length,
			path: [
				c,
				0,
				0
			]
		}
	});
};
//#endregion
export { n as actionHandler };
